import { api } from '@/lib/api';
import { useTranslation } from '@/lib/i18n';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ClienteSolicitacao } from '../../-components/opcoes/cliente';
import PaginaCliente from '../../-components/pagina-cliente/pagina-cliente';
import { MAXIMO_CODIGO, parseIdCliente } from '../../-utils/parametros-cliente';
import AquisicaoPageComponent from './-component';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/aquisicoes/$codigo',
)({
  params: {
    parse: params => ({ codigo: parseIdCliente(params.codigo, MAXIMO_CODIGO) }),
    stringify: params => ({ codigo: String(params.codigo) }),
  },
  context: ({ params }) => ({
    aquisicaoQueryOptions: api.queryOptions(
      'get',
      '/clientes/aquisicoes/{codigo}',
      {
        params: { path: { codigo: params.codigo } },
      },
      { staleTime: 1000 * 60 },
    ),
    cliente: {
      tipoCliente: 'Aquisicao',
      codigo: params.codigo,
    } satisfies ClienteSolicitacao as ClienteSolicitacao,
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.aquisicaoQueryOptions);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('private');

  const { aquisicaoQueryOptions } = Route.useRouteContext();
  const search = Route.useSearch();

  const { isPending, error } = useQuery(aquisicaoQueryOptions);

  return (
    <PaginaCliente
      search={search}
      carregando={isPending}
      erro={error}
      opcaoAberta={<Outlet />}
      opcoes={[
        {
          texto: t($ => $.clientes.opcoes.outrasSolicitacoes.titulo),
          to: '/comercial/produto/clientes/aquisicoes/$codigo/outras-solicitacoes',
        },
        {
          texto: t($ => $.clientes.opcoes.minhasSolicitacoes.titulo),
          to: '/comercial/produto/clientes/aquisicoes/$codigo/minhas-solicitacoes',
        },
      ]}
    >
      <AquisicaoPageComponent />
    </PaginaCliente>
  );
}
